import GA from "./ga";

const trackQRCodeOpened = (code) => GA.send({
  name: 'qr-code',
  category: 'register',
  action: `${code}`,
  label: navigator.userAgent
})

export {trackQRCodeOpened}
